import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../../../../assets/Colors';

export const useStyles = makeStyles({
    container: {
        margin: '10px 0px',
    },
    influencerDecoration: {
        border: '1px solid',
        borderColor: Colors.main.primary,
        padding: 1,
    },
    text: {
        fontSize: 15,
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
        color: Colors.text.light,
        lineHeight: '1.2em',
    },
    avatar: {
        width: 40,
        height: 40,
        marginRight: 5,
        borderRadius: '50%',
        padding: 2,
    },
    adminUser: {
        width: 45,
        height: 45,
        marginRight: 5,
        borderRadius: '50%',
        padding: 2,
        border: '2px solid green',
    },
    usernameText: {
        maxHeight: 26,
        maxWidth: '60%',
        flexWrap: 'nowrap',
        wordBreak: 'break-all',
        overflow: 'hidden',
    },
    extraNegativeMargin: {
        marginLeft: -15,
    },
    chooseButton: {
        backgroundColor: Colors.main.primary,
        color: Colors.text.light,
    },
    textContainer: {
        maxWidth: '70%',
        wordBreak: 'break-word',
        margin: '5px 5px',
    },
    userName: {
        color: Colors.main.primary,
        fontSize: 14,
        marginBottom: 5,
    },
    chatMessage: {},
    instructionText: {},
    icon: {
        margin: 0,
        padding: 0,
        width: 15,
        height: 15,
        color: 'black',
    },
});
